module.exports = __webpack_public_path__ + "./assets/img_hualien_color__b967199dc79af5c06a8c96666339ad42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_hualien_color.jpg
// module id = 603
// module chunks = 12